import styled, { css } from "styled-components";
import tw from "twin.macro";

import { Badge } from "../Badge";
import { BoxSizingStyle } from "../BoxSizingStyle";
import { Button } from "../Button/Button";
import { FontStyle } from "../FontStyle";
import { Body2 } from "../Typography/Variants/Body2";

interface StyledCounterButtonProps {
  $active?: boolean;
  $selected?: boolean;
}

export const StyledCounterButtonWrapper = styled.div`
  ${tw`tw-flex`}
  ${FontStyle}
  ${BoxSizingStyle}
  width: fit-content;
`;

StyledCounterButtonWrapper.displayName = "StyledCounterButtonWrapper";

export const StyledCounterButton = styled(Button)<StyledCounterButtonProps>`
  ${(props) =>
    props.$active &&
    !props.disabled &&
    css`
      padding: 0 8px;

      svg {
        fill: var(--color-primary);
      }

      &:hover {
        background: var(--color-primary-300);
      }
    `}

  ${(props) =>
    props.$selected &&
    css`
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      background-color: var(--color-primary-200);
    `}

  ${(props) =>
    !props.$selected &&
    css`
      @media (max-width: 768px) {
        width: 32px;
      }
    `}

    ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

StyledCounterButton.displayName = "StyledCounterButton";

export const StyledCounterButtonReset = styled(Button)`
  background-color: var(--color-primary-200);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  &:hover,
  &:focus-visible {
    background-color: var(--color-primary-300);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

StyledCounterButtonReset.displayName = "StyledCounterButtonReset";

export const StyledCounterButtonLabel = styled(Body2)<{ $active?: boolean }>`
  ${tw`tw-pointer-events-none`}

  @media (max-width: 768px) {
    display: none;
  }

  ${StyledCounterButton}:hover && {
    ${(props) =>
      !props.$active &&
      css`
        color: var(--color-theme-900);
      `}
  }

  ${(props) =>
    props.$active &&
    css`
      color: var(--color-primary);
    `}
`;

StyledCounterButtonLabel.displayName = "StyledCounterButtonLabel";

export const StyledBadge = styled(Badge)`
  margin-left: 4px;
  margin-right: -6px;
`;

StyledBadge.displayName = "StyledBadge";
